import React, { useEffect } from "react";
import { Card, CardBody, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

// Alt Bileşenler (Kendi klasör yapına göre yolları ayarlayabilirsin)
import FileLeftBar from "./FileLeftBar";
import FileList from "./FileList";
import RecentFile from "./RecentFile";
import Storage from "./Storage";

const DosyaYoneticisi = () => {
  document.title = "Dosya Yöneticisi | HarmanaGEL Admin";
  const navigate = useNavigate();

  // Admin Kontrolü: Sadece ID: 3 (Yönetici) bu sayfayı görebilir
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  useEffect(() => {
    if (!isAdmin) {
      toast.error("Dosya Yöneticisine erişim yetkiniz yok!");
      navigate("/dashboard");
    }
  }, [isAdmin, navigate]);

  // Depolama Alanı Grafiği (Örnek: %76 Dolu)
  // İleride bunu sunucunun disk boyutunu okuyan bir API'ye bağlayabiliriz.
  const series = [76];
  const options = {
    chart: {
      height: 150,
      type: "radialBar",
      sparkline: { enabled: true },
    },
    colors: ["#556ee6"], // HarmanaGEL birincil rengi
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: "97%",
          margin: 5, 
        },
        hollow: { size: "60%" },
        dataLabels: {
          name: { show: false },
          value: { offsetY: -2, fontSize: "16px" },
        },
      },
    },
    grid: { padding: { top: -10 } },
    stroke: { dashArray: 3 },
    labels: ["Depolama"],
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Sistem" breadcrumbItem="Dosya Yöneticisi" />
          
          <div className="d-xl-flex">
            <div className="w-100">
              <div className="d-md-flex">
                
                {/* Sol Menü: Klasörler (Resimler, Belgeler, Videolar vb.) */}
                <FileLeftBar />
                
                <div className="w-100">
                  <Card className="shadow-sm border-0">
                    <CardBody>
                      {/* Klasör ve Dosya İkonlarının Listelendiği Alan */}
                      <FileList />
                      
                      {/* Son Yüklenen Dosyaların Tablosu (uploads.php'den gelenler) */}
                      <RecentFile />
                    </CardBody>
                  </Card>
                </div>

              </div>
            </div>
            
            {/* Sağ Panel: Depolama Durumu Grafiği */}
            <Storage options={options} series={series} />
          </div>

        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default DosyaYoneticisi;